/** Dinero beraETH wrapper read surface.
 *
 *  beraETH is NOT an ERC-4626 — `asset()`/`convertToAssets()` revert. It
 *  is a wrapper over the rberaETH base LST and exposes its own
 *  underlying-per-share getter `LSTPerToken()` (1e18-scaled rberaETH/ETH
 *  per beraETH). */
export const DineroBeraEthAbi = [
  {
    name: 'LSTPerToken',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
